import React from 'react';

const BonusBuy = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.91667 2.5H12.0833C12.4149 2.5 12.7328 2.6317 12.9672 2.86612C13.2016 3.10054 13.3333 3.41848 13.3333 3.75C13.3333 4.52355 13.026 5.26541 12.4791 5.81239C11.9321 6.35938 11.1902 6.66667 10.4167 6.66667H9.58333C8.80978 6.66667 8.06792 6.35938 7.52094 5.81239C6.97396 5.26541 6.66667 4.52355 6.66667 3.75C6.66667 3.41848 6.79836 3.10054 7.03278 2.86612C7.2672 2.6317 7.58514 2.5 7.91667 2.5Z",
      stroke: "white",
      strokeOpacity: "0.6",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.33333 14.1667V13.3333C3.33333 11.5652 4.03571 9.86953 5.28595 8.61929C6.5362 7.36905 8.23189 6.66667 10 6.66667C11.7681 6.66667 13.4638 7.36905 14.714 8.61929C15.9643 9.86953 16.6667 11.5652 16.6667 13.3333V14.1667C16.6667 15.0507 16.3155 15.8986 15.6904 16.5237C15.0652 17.1488 14.2174 17.5 13.3333 17.5H6.66667C5.78261 17.5 4.93476 17.1488 4.30964 16.5237C3.68452 15.8986 3.33333 15.0507 3.33333 14.1667Z",
      stroke: "white",
      strokeOpacity: "0.6",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { BonusBuy };
//# sourceMappingURL=BonusBuy.js.map
